import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { useRoiIndustryContext } from "../../../context/roi/industry/RoiIndustryContext";
import Table from "../../../components/table/Table";
import useSWR from "swr";
import { fetchData } from "../../../lib/dashboard/data";
import { faCols_roiIndustryStocks } from "../../../components/tableHeaderNames/HeaderName";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  boxShadow: 24,
  outline: "none",
  borderRadius: "12px",
};

const highlightedCols = [
  "daily_roi",
  "weekly_roi",
  "monthly_roi",
  "quarterly_roi",
  "half_yearly_roi",
  "yearly_roi",
  "three_years_roi",
];

export default function RoiIndustryStocks() {
  const { showStocks, setShowStocks, selectedIndustry } =
    useRoiIndustryContext();

  const handleClose = () => setShowStocks(false);

  const stocks = useSWR(
    selectedIndustry.id ? `/stock-market/roi/${selectedIndustry.id}` : null,
    fetchData,
    {
      dedupingInterval: 60000,
    }
  );

  const percentCols = [
    "weekly_roi",
    "monthly_roi",
    "quarterly_roi",
    "half_yearly_roi",
    "yearly_roi",
  ]

  return (
    <Modal open={showStocks} onClose={handleClose}>
      <Box sx={style}>
        <Table
          tableData={stocks}
          tableTitle={{ title: "سهم‌ها", desc: selectedIndustry.name }}
          faCols={faCols_roiIndustryStocks}
          height={"70vh"}
          highlightedCols={highlightedCols}
          percentCols={percentCols}
        />
      </Box>
    </Modal>
  );
}
